import { createFileRoute, redirect } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/stores/authStore'
import { isDemoIssue } from '@/shared/constants/demo-data'
import { IssueDetailPage } from '@/systems/issues/features/issue-detail/components/IssueDetailPage'
import { issueDetailQueryOptions } from '@/systems/issues/features/issue-detail/hooks/useIssueDetail'

// Canonical issue detail route. Loaded by the HOD inbox (S6), the
// entity-detail Issues tab "View" button, the site-detail Issues tab
// "View" button, and the standalone /issues page rows. Issue ID is the
// only path param — no entity context required.
export const Route = createFileRoute('/issues/$issueId')({
  beforeLoad: ({ params }) => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    if (isDemoIssue(params.issueId)) {
      throw redirect({ to: '/issues' })
    }
  },
  loader: ({ params, context: { queryClient } }) => {
    void queryClient.prefetchQuery(issueDetailQueryOptions(params.issueId))
  },
  component: IssueDetailRoute,
})

function IssueDetailRoute() {
  const { issueId } = Route.useParams()
  return <IssueDetailPage issueId={issueId} />
}
